module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_11.6dbb0c88.png";